/* eslint-disable indent */
import { Carousel } from 'components/carousels/Carousel'
import { NoSavedReleases } from 'components/release-calendar/NoSavedReleases'
import { ReleaseCard } from 'components/release-calendar/ReleaseCard'
import { ReleaseCardSkeleton } from 'components/release-calendar/ReleaseCardSkeleton'
import { Releases } from 'components/release-calendar/ReleasesList'
import { useFutureSavedReleases, usePastSavedReleases } from 'contexts'
import useTranslation from 'next-translate/useTranslation'
import { range } from 'utils/arrays'

export function SavedTab() {
  const { t } = useTranslation('release_calendar')
  const { data: pastReleases, isFetchedAfterMount: isPastReleasesFetched } =
    usePastSavedReleases()
  const { data: futureReleases, isFetchedAfterMount: isFutureReleasesFetched } =
    useFutureSavedReleases()

  return (
    <>
      {isFutureReleasesFetched &&
        !futureReleases.list.length &&
        isPastReleasesFetched &&
        !pastReleases.list.length && (
          <div className='w-full p-6 md:px-12'>
            <div className='mx-auto max-w-[90rem]'>
              <NoSavedReleases />
            </div>
          </div>
        )}

      {(!isFutureReleasesFetched || Boolean(futureReleases?.list.length)) && (
        <>
          <div className='mt-10 hidden px-6 sm:mt-8 md:mb-4 md:px-12 [@media(min-width:369px)]:block'>
            <div className='mx-auto max-w-[90rem]'>
              <h4 className='font-body text-xl font-medium tracking-normal'>
                {t('upcoming_releases')}
              </h4>
            </div>
          </div>

          <section className='mt-4 flex w-full flex-col px-6 pb-12 sm:mt-0 md:px-12'>
            <Releases
              mappedReleases={futureReleases?.mapped || {}}
              skeletonsCount={5}
              shouldDisplayDate
            />
          </section>
        </>
      )}

      {(!isPastReleasesFetched || Boolean(pastReleases?.list.length)) && (
        <div className='w-full bg-warm-50 py-6'>
          <Carousel
            title={t('recent_releases')}
            headerClassName='!items-end !mb-4'
            titleClassName='font-body text-lg font-medium tracking-normal sm:text-xl'
          >
            {!pastReleases?.list.length &&
              range(0, 6).map(i => (
                <ReleaseCardSkeleton key={i} keepAspectRatio />
              ))}

            {Boolean(pastReleases?.list.length) &&
              pastReleases?.list.map((release, index) => (
                <ReleaseCard key={index} {...release} keepAspectRatio />
              ))}
          </Carousel>
        </div>
      )}
    </>
  )
}
